@app.controller 'JouleHeroController', ($element) ->
  @content =
    title: 'Meet Joule,'
    subtitle: 'Your Next Kitchen Essential.'
    image: 'https://d3awvtnmmsvyot.cloudfront.net/api/file/62xsiMSwSi2s5mpsLsp6'
    mobileImage: 'https://d3awvtnmmsvyot.cloudfront.net/api/file/oWQCMHzHQC6DO9hW9e0x'
    youtubeId: 'WYXCjZbjPZc'
    international:
      title: 'Meet Joule,'
      subtitle: 'Your Next Kitchen Essential.'
      description: 'Available outside the US starting in late 2016. Stay tuned for updates on special pricing for international community members.'
  @theme = 'light'

  @getAspect = ->
    return 'portrait' if ($element.children()[0].clientHeight / 9) > ($element.children()[0].clientWidth / 16)
    return 'landscape'

  @isVideoVisible = false

  @showVideo = =>
    @isVideoVisible = true

  @hideVideo = =>
    @isVideoVisible = false

  @handleEmbedVideoClicked = => @hideVideo()

  this

@app.controller 'JouleController', ($scope, $rootScope, currentUser, navService, MetadataService, LocationService, responsiveService, $window, AnalyticsService, PricingService, mobileDetectionService) ->

  @isViewportMobile = responsiveService.isViewportMobile()
  @isMobileDevice = mobileDetectionService.isMobile
  @responsiveWidth = responsiveService
  angular.element($window).bind 'resize', =>
    @isViewportMobile = responsiveService.isViewportMobile()
    @setNav()
    $rootScope.$safeApply()

  # Setting the main site nav for /joule
  @setNav = =>
    if @isViewportMobile
      navService.setState('nav-ghost')
    else
      navService.setState('nav-ghost')

  @setNav()

  # Joule Page Nav
  @pageNav =
    type: 'pageNav'
    meta:
      items: [
        content:
          type: 'Joule'
          customButton:
            type: 'shopify'
            title: 'Preorder'
            theme: 'solid orange'
            sku: 'cs10001'
      ]
    theme: 'gray'

  # Joule Timeline
  @timeline =
    type: 'custom'
    meta:
      items: [
        content:
          template: '/templates/pages/joule/jouleTimeline/jouleTimeline.html'
      ]
    theme: 'light'
    size: 'full'

  canonical = '/joule'
  title = 'Joule: Sous Vide by ChefSteps'
  description = 'Joule is the sous vide tool that changes everything. Controlled by a groundbreaking custom app, Joule is a sleek, powerful cooking tool that makes sous vide a real part of today’s kitchen.'
  image = 'https://d3awvtnmmsvyot.cloudfront.net/api/file/GXeldtdqSHyi2QI4cdGt'
  MetadataService.set
    title: title
    description: description
    keywords: "joule, sous vide, chefsteps, circulator"
    canonical: canonical
    image: image
    og:
      url: canonical


  if currentUser?.admin
    @showMenu = true

  # Pricing
  @isInUS = LocationService.isInUS()
  @currentUserPremium = currentUser?.premium
  @currentUserUsedDiscount = currentUser?.used_circulator_discount
  @msrp = 199
  # Drys up the price, however we actually want to use the resolve priceData
  # At the moment priceData does not seem to resolve properly when using ui-sref
  @price = 199

  # Joule Tracking
  AnalyticsService.track 'Viewed Product', {
    sku: 'cs10001'
    name: 'Joule'
    price: @price
  }

  @track = (eventName) ->
    console.log 'tracking: ', eventName
    AnalyticsService.track "Joule #{eventName}"

  this
